import { ILLUSTRATION_NAMES as e } from "./illustration-constants.js";
import { computed as t, createBlock as n, createCommentVNode as r, openBlock as i, resolveDynamicComponent as a } from "vue";
import { illustrations as o } from "@dialpad/dialtone-icons/vue";
//#region components/illustration/illustration.vue
var s = /* @__PURE__ */ Object.assign({ name: "DtIllustration" }, {
	__name: "illustration",
	props: { name: {
		type: String,
		required: !0,
		validator: (t) => e.includes(t)
	} },
	setup(e) {
		let s = e, c = t(() => o[`./src/illustrations/${s.name}.vue`]);
		return (e, t) => c.value ? (i(), n(a(c.value), {
			key: 0,
			"data-qa": e.$attrs["data-qa"] ?? "dt-illustration"
		}, null, 8, ["data-qa"])) : r("", !0);
	}
});
//#endregion
export { s as default };

//# sourceMappingURL=illustration.js.map